export * from './LoyaltyOfferCardText';
